// Centralized config for the Shopify Chatbot frontend

// Fallback values for static deployment (Azure Static Web Apps etc.)
const DEFAULT_CONFIG = {
  API_BASE: 'https://chatbot-proxy.azure-api.net/api',
  SHOPIFY_API_KEY: 'e01adf90e60dcfdb4e39b5485859d18b',
  APP_HANDLE: 'hyderabot',
  SUPPORT_EMAIL: 'support@hyderabot.in',
};

export const config = {
  API_BASE: DEFAULT_CONFIG.API_BASE,
  SHOPIFY_API_KEY: DEFAULT_CONFIG.SHOPIFY_API_KEY,
  APP_HANDLE: DEFAULT_CONFIG.APP_HANDLE,
  SUPPORT_EMAIL: DEFAULT_CONFIG.SUPPORT_EMAIL,
};

export const DEFAULT_API_VERSION = '2023-10';
export const DEFAULT_PLAN_NAMES = ['Free', 'Basic', 'Standard', 'Premium'];

export const PLAN_FEATURES = {
  'Free': ['FAQs'],
  'Basic': ['FAQs', 'General product recommendations', 'Order based product recommendations'],
  'Standard': ['FAQs', 'General product recommendations', 'Order based product recommendations','Notifications', 'Live chat', 'Customization', 'Removed branding for Chatbot'],
  'Premium': ['FAQs', 'General product recommendations', 'Order based product recommendations','Notifications', 'Live chat', 'Customization', 'Removed branding for Chatbot', 'Advanced features'],
};

// Shopify OAuth scopes for this app
export const SHOPIFY_OAUTH_SCOPES = 'read_orders,read_products,read_inventory,read_customers,read_themes';

// Add more frontend constants as needed
